import { Component, Input, OnInit } from '@angular/core';
import { GamificationLeagueDto } from '../../shared/types/GamificationLeagueDto';
import { OeAppService } from '../../shared/oe-app.service';
import { TranslationService } from '../../shared/translation.service';

@Component({
  selector: 'lp2-leaderboard-initial',
  templateUrl: './leaderboard-initial.component.html',
  styleUrls: ['./leaderboard-initial.component.scss'],
})
export class LeaderboardInitialComponent implements OnInit {
  @Input()
  leagues: GamificationLeagueDto[];

  gamificationS3Url = `//${this.oeApp.s3BucketHost()}/gamification`;

  language = 'en';

  constructor(
    private oeApp: OeAppService,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    this.language = this.translationService.getCurrentLanguage();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/leaderboard-initial/leaderboard-initial.component.ts